import { Helper } from '../Helper';
export class RawEnumeratorSomeHelper extends Helper {
    constructor(options) {
        super();
        this.each = options.each;
    }
    emit(sb, node, options) {
        sb.emitHelper(node, options, sb.helpers.rawIteratorSomeBase({
            each: (innerOptions) => {
                sb.emitSysCall(node, 'Neo.Enumerator.Value');
                this.each(innerOptions);
            },
        }));
    }
}

//# sourceMappingURL=RawEnumeratorSomeHelper.js.map
